import CIMSTable from 'components/CIMSTable'
import { useConnectionsContext } from './ConnectionsContext'
import { useColumns } from './hooks/useColumns'
import { useCreate } from './hooks/useCreate'
import { useCustom } from './hooks/useCustom'
import { useEdit } from './hooks/useEdit'
import { useExpand } from './hooks/useExpand'
import { useRemove } from './hooks/useRemove'
import { useRestore } from './hooks/useRestore'

const Connections: React.FC = () => {
  const { data, fetching, refetch: onReload } = useConnectionsContext()
  const columns = useColumns()
  const expand = useExpand()
  const create = useCreate()
  const remove = useRemove()
  const restore = useRestore()
  const edit = useEdit()
  const custom = useCustom()

  return (
    <CIMSTable
      records={data}
      columns={columns}
      rowKey="id"
      actions={{
        header: { onReload, create },
        row: {
          remove,
          restore,
          edit,
          custom,
          help: 'Syncs are automatically performed each night',
        },
      }}
      loading={fetching}
      expand={expand}
    />
  )
}

export default Connections
